/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable react/function-component-definition */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-plusplus */
import React, { useEffect, useState } from 'react';
import { Modal, message, Button, Table, Input, Tag } from 'antd';
import moment from 'moment';
import { DataService } from '../../../config/dataService/dataService';
import { TableWrapper } from '../../../container/styled';
import { TRAINING_STATUS_COLORS } from '../../../config/config';

const FormDialog = ({ showDialog, editId }) => {
  const [busy, setBusy] = useState(false);
  const [tableData, setTableData] = useState([]);

  const fetchTableData = async () => {
    try {
      setBusy(true)
      const response = await DataService.post('/emp-training/get-training-by-id', { training_id: editId });
      const { data } = response.data;
      setTableData(data);
      setBusy(false)
    } catch (error) {
      message.error(`Error fetching table data:  ${error.message}`)
      setBusy(false)
    }
  };

  useEffect(() => {
    if (editId) {
      fetchTableData();
    }
  }, [editId]);

  const TableColumns = [
    {
      title: 'Course Name',
      dataIndex: 'course_name',
      key: 'course_name',
      field: 'course_name',
      export: true,
    },
    {
      title: () => {
        return (
          <div className='flex'>
            Center Name
          </div>
        )
      },
      dataIndex: 'center_name',
      key: 'center_name',
      field: 'center_name',
      export: true,
    },
    {
      title: 'StartedAt',
      dataIndex: 'start_date_time',
      key: 'start_date_time',
      field: 'start_date_time',
      onCell: () => ({ className: 'w-20' }),
      export: true,
      render: (start_date_time) => {
        if (!start_date_time) return <p >NOT DEFINED</p>
        return <p >{moment(start_date_time).format('YYYY-MM-DD hh:mm a')}</p>
      },
    },
    {
      title: 'EndedAt',
      dataIndex: 'end_date_time',
      key: 'end_date_time',
      field: 'end_date_time',
      onCell: () => ({ className: 'w-20' }),
      export: true,
      render: (end_date_time) => {
        if (!end_date_time) return <p >NOT DEFINED</p>
        return <p >{moment(end_date_time).format('YYYY-MM-DD hh:mm a')}</p>
      },
    },
    {
      title: () => {
        return (
          <div className='flex justify-center'>
            Status
          </div>
        )
      },
      dataIndex: 'training_status',
      key: 'training_status',
      field: 'training_status',
      onCell: () => ({ className: 'w-20' }),
      export: true,
      render: (training_status) => {
        training_status = Number(training_status);
        try {
          const { color, label } = TRAINING_STATUS_COLORS[training_status]
          return (
            <div className="flex justify-content-center">
              <div className='taglist-wrap select-none'>
                <Tag color={color}>{label}</Tag>
              </div>
            </div>
          )
        } catch (error) {
          return <p>Undefined</p>
        }
        // training_status = Number(training_status);
        // const { color, label } = TRAINING_STATUS_COLORS[training_status]
        // return (
        //   <div className="flex justify-content-center">
        //     <div className='taglist-wrap select-none'>
        //       <Tag color={color}>{label}</Tag>
        //     </div>
        //   </div>
        // )
      },
    },
  ];

  return (
    <Modal
      open
      title='Training Courses Employee Enrolled In'
      cancelText="Cancel"
      width="70%"

      // onCancel={() => showDialog(false)}
      // onOk={() => form.submit()}
      centered
      footer={[
        <Button key="cancel" loading={busy} onClick={() => showDialog(false)} disabled={busy}>
          Close
        </Button>,
      ]}
      cancelButtonProps={{ disabled: busy }}
      destroyOnClose
    >

      <div className="ninjadasj-datatable mh-[50%]"
        style={{ minHeight: 'calc(100vh - 300px)' }}
      >
        <TableWrapper>
          <Table
            rowKey={(record) => `${record.id}`} // Generate a unique key for each row
            loading={busy}
            bordered
            virutal
            size='middle'
            className='border rounded drop-shadow-sm'
            pagination={false}
            // rowSelection='multiple'
            dataSource={tableData}
            columns={TableColumns}
            scroll={{ y: 'calc(100vh - 300px)' }} // Adjust height based on dialog size
          />
        </TableWrapper>
      </div>
    </Modal>
  );
};

export default FormDialog;
